export const product = {
  ct: 'CT Browser',
  nft: 'CT NFT',
  farm: 'CT Farm',
  farm_pro: 'CT Farm PRO',
  pool: 'CT Pool',
};
